import { FC } from 'react';
import { ButtonPrimary, Form, Tabs } from '@lambdacurry/component-library';
import { useSubscriptionProductsQuery } from 'lib/home/generated/queries';
import { MedusaProductVariant } from 'lib/home/generated/types/api';
import { MealPlansInputGroup } from '../..';
import { generateTabs } from './SelectPlanForm.helpers';

export interface SelectPlanFormValues {
  selectedPlan: string;
}

export interface SelectPlanFormProps {
  initialValues: SelectPlanFormValues;
  handleSubmit: (values: SelectPlanFormValues) => void;
}

export const SelectPlanForm: FC<SelectPlanFormProps> = ({ initialValues, handleSubmit }) => {
  const { data: subscriptionProducts } = useSubscriptionProductsQuery();

  return (
    <>
      {!subscriptionProducts && `Loading subscription products...`}

      {subscriptionProducts && (
        <Form enableReinitialize initialValues={initialValues} onSubmit={handleSubmit}>
          {formikProps => {
            const keys = Object.keys(subscriptionProducts);
            const plans = Object.values(subscriptionProducts);

            return (
              <>
                {keys.length > 1 && (
                  <Tabs
                    className="meal-plans-input-group__tabs"
                    tabs={generateTabs(formikProps.values, subscriptionProducts)}
                  />
                )}

                {keys.length <= 1 && (
                  <MealPlansInputGroup
                    name="selectedPlan"
                    plans={
                      plans
                        .flat()
                        .sort((a: MedusaProductVariant, b: MedusaProductVariant) =>
                          a.sku < b.sku ? -1 : 1
                        ) as MedusaProductVariant[]
                    }
                    values={formikProps.values}
                  />
                )}

                <ButtonPrimary
                  className="w-full md:w-56"
                  data-cy="submit-button"
                  type="submit"
                  disabled={!formikProps.values.selectedPlan}
                >
                  Continue
                </ButtonPrimary>
              </>
            );
          }}
        </Form>
      )}
    </>
  );
};
